import { render, staticRenderFns } from "./Voters.vue?vue&type=template&id=422e63b3&"
import script from "./Voters.vue?vue&type=script&lang=ts&"
export * from "./Voters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports